import Joi from '@hapi/joi'

export const deductionSchemaObject = {
    //groupId: Joi.string().invalid("1").required().label("Group"),
    //factoryId: Joi.string().required().label("Factory"),
    //operationTypeId: Joi.string().required().label("Operation Type"),
    //routeId: Joi.string().allow("", null).label("Route"),
    //estateId: Joi.string().allow("", null).label("Estate"),
    //divisionId: Joi.string().label("Division"),
    //deductionType: Joi.string().invalid("1").required().label("Deduction Type"),
    //applyMethod: Joi.string().required().label("Apply Method"),
    //defaultValue: Joi.string().required().label("DefaultValue"),
    //minimumValue: Joi.string().allow("", null).label("Minimum Value")
    groupID: Joi.number().invalid(0).required().label("Group"),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity"),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Point Category"),
    collectionCategoryMenuID: Joi.number().invalid(0).required().label("Collection Category Menu"),
    deductionTypeID: Joi.number().invalid(0).required().label("Deduction Type"),
    applyMethodID: Joi.number().invalid(0).required().label("Apply method"),
    // deductionOrder: Joi.number().label("Deduction Order"),
    // deductionSequence: Joi.number().label("Deduction Sequence"),
    
    minimumValue: Joi.number().positive().allow(0).required().label("MinimumValue").messages({
        "number.empty": `Minimum Value`,
        "any.required": `Please Enter Minimum Value`
    }),
    
    defaultValue: Joi.number().positive().allow(0).required().label("Default Value").messages({
        "number.empty": `Default Value`,
        "any.required": `Please Enter Default Value`
    }),
    defaultValueEnabled: Joi.boolean().label("Default Value Enabled"),
    active: Joi.boolean().label("Active"),
    fixed:Joi.boolean().label("Active")

}















